import cx from 'classnames'

import { useGameSlug } from '@/features/storefronts/game-provider'

import storefronts from '../storefronts.module.scss'

type Props = Readonly<{
  children?: React.ReactNode
}>

export const GameContainer = ({ children }: Props) => {
  const gameSlug = useGameSlug()
  return <section className={cx(storefronts.gameContainer, storefronts[gameSlug])}>{children}</section>
}
